import global from './global'
import user from './user'

export default {
  global,
  user
}
